import { render, staticRenderFns } from "./inputRadio.vue?vue&type=template&id=65d49b22&scoped=true"
import script from "./inputRadio.vue?vue&type=script&lang=js"
export * from "./inputRadio.vue?vue&type=script&lang=js"
import style0 from "./inputRadio.vue?vue&type=style&index=0&id=65d49b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d49b22",
  null
  
)

export default component.exports